import LanguagesEdit from './languagesEdit'
export default LanguagesEdit
